"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Destination = exports.defaultDestinationConfig = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var hooks_1 = require("preact/hooks");
var countriesWithoutPostalCode_1 = require("./countriesWithoutPostalCode");
var countries_1 = require("../../fixtures/countries");
exports.defaultDestinationConfig = {
    descriptionLabel: 'Get a cost estimate to ship these goods from:',
    buttonText: 'Get Costs',
    countryLabel: 'Country',
    zipLabel: 'Destination Postal/Zip Code',
    cityLabel: 'Destination City',
};
var Destination = function (_a) {
    var parsedOrigin = _a.parsedOrigin, textConfig = _a.textConfig, setDestination = _a.setDestination;
    var _b = (0, hooks_1.useState)('US'), country = _b[0], setCountry = _b[1];
    var _c = (0, hooks_1.useState)(false), isWithoutPostal = _c[0], setIsWithoutPostal = _c[1];
    var _d = (0, hooks_1.useState)(''), postalCode = _d[0], setPostalCode = _d[1];
    var isDestinationError = false;
    var enabled = true;
    var onCountryChange = function (e) {
        setCountry(e.target.value);
        if (countriesWithoutPostalCode_1.withoutPostal.has(e.target.value)) {
            setIsWithoutPostal(true);
            setPostalCode('');
        }
        else {
            setIsWithoutPostal(false);
        }
    };
    var onPostalCodeInput = function (e) {
        setPostalCode(e.target.value);
    };
    var onFormSubmit = function (e) {
        e.preventDefault();
        setDestination({
            postal_code: postalCode,
            country: country,
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "artajs__modal__form", children: [(0, jsx_runtime_1.jsx)("p", { class: "artajs__modal__form__row__context", children: textConfig.descriptionLabel }), (0, jsx_runtime_1.jsx)("p", { class: "artajs__modal__form__row__location", children: parsedOrigin ? ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("strong", { class: "artajs__modal__capitalize", children: parsedOrigin }), ' ', (0, jsx_runtime_1.jsx)("span", { class: "artajs__modal__form__light", children: textConfig.detailOriginLabel })] })) : ((0, jsx_runtime_1.jsx)("span", { children: "..." })) }), (0, jsx_runtime_1.jsxs)("form", { onSubmit: onFormSubmit, children: [(0, jsx_runtime_1.jsxs)("div", { className: "artajs__modal__form__row", children: [(0, jsx_runtime_1.jsx)("strong", { className: "artajs__modal__form__label", children: textConfig.countryLabel }), (0, jsx_runtime_1.jsx)("label", { class: "artajs__modal__textfield__outlined ".concat(isDestinationError
                                    ? 'artajs__modal__textfield__outlined__error'
                                    : ''), for: "country", children: (0, jsx_runtime_1.jsx)("select", { id: "country", onChange: onCountryChange, value: country, children: countries_1.countries.map(function (c) { return ((0, jsx_runtime_1.jsx)("option", { value: c.code, children: c.name }, c.code)); }) }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "artajs__modal__form__row", children: [(0, jsx_runtime_1.jsx)("strong", { className: "artajs__modal__form__label", children: isWithoutPostal ? textConfig.cityLabel : textConfig.zipLabel }), (0, jsx_runtime_1.jsx)("label", { class: "artajs__modal__textfield__outlined ".concat(isDestinationError
                                    ? 'artajs__modal__textfield__outlined__error'
                                    : ''), for: "postal_code", children: (0, jsx_runtime_1.jsx)("input", { id: "postal_code", onInput: onPostalCodeInput, placeholder: "", type: "text", value: postalCode }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "artajs__modal__form__row", children: (0, jsx_runtime_1.jsx)("button", { disabled: !enabled || postalCode === '' ? true : false, type: "submit", children: textConfig.buttonText }) })] })] }));
};
exports.Destination = Destination;
